import { render, staticRenderFns } from "./SalesTrend.vue?vue&type=template&id=4475d012&scoped=true"
import script from "./SalesTrend.vue?vue&type=script&lang=js"
export * from "./SalesTrend.vue?vue&type=script&lang=js"
import style0 from "./SalesTrend.vue?vue&type=style&index=0&id=4475d012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475d012",
  null
  
)

export default component.exports